(() => {
  const header = document.querySelector('[data-site-header]');
  const drawer = header?.querySelector('[data-site-drawer]');
  const themeToggle = header?.querySelector('[data-color-theme-toggle]');

  if (!header) {
    return;
  }

  const root = document.documentElement;
  const themeStorageKey = root.dataset.colorThemeStorageKey || 'serenova-color-theme';

  const syncThemeToggle = () => {
    if (!themeToggle) {
      return;
    }

    const isLight = root.dataset.colorTheme === 'light';
    const label = isLight ? themeToggle.dataset.darkLabel : themeToggle.dataset.lightLabel;
    themeToggle.setAttribute('aria-pressed', String(isLight));
    themeToggle.setAttribute('aria-label', label);
    themeToggle.setAttribute('title', label);
  };

  const applyTheme = (theme) => {
    root.dataset.colorTheme = theme;

    try {
      localStorage.setItem(themeStorageKey, theme);
    } catch (error) {
      root.dataset.colorTheme = theme;
    }

    syncThemeToggle();
  };

  syncThemeToggle();

  themeToggle?.addEventListener('click', () => {
    const nextTheme = root.dataset.colorTheme === 'light' ? 'dark' : 'light';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (document.startViewTransition && !reduceMotion) {
      document.startViewTransition(() => applyTheme(nextTheme));
      return;
    }

    applyTheme(nextTheme);
  });

  let lastScrollY = window.scrollY;

  const syncHeader = () => {
    const currentScrollY = window.scrollY;
    const shouldUseCompactState = currentScrollY > 32;
    header.classList.toggle('is-scrolled', shouldUseCompactState);

    if (drawer?.open && !drawer.contains(document.activeElement) && Math.abs(currentScrollY - lastScrollY) > 4) {
      drawer.open = false;
    }

    lastScrollY = currentScrollY;
  };

  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });
  window.addEventListener('resize', syncHeader);

  if (!drawer) {
    return;
  }

  const drawerToggle = drawer.querySelector('summary');
  const desktopNavigation = header.querySelector('.site-nav');
  const mobileNavigation = window.matchMedia('(max-width: 1320px)');

  const closeDrawer = (restoreFocus = false) => {
    drawer.open = false;
    if (restoreFocus) {
      drawerToggle?.focus({ preventScroll: true });
    }
  };

  drawer.addEventListener('keydown', (event) => {
    if (drawer.open && event.key === 'Escape') {
      event.preventDefault();
      closeDrawer(true);
    }
  });

  drawer.addEventListener('focusout', (event) => {
    if (drawer.open && event.relatedTarget && !drawer.contains(event.relatedTarget)) {
      closeDrawer();
    }
  });

  mobileNavigation.addEventListener('change', (event) => {
    const focusedElement = document.activeElement;

    if (event.matches) {
      if (desktopNavigation?.contains(focusedElement)) {
        drawerToggle?.focus({ preventScroll: true });
      }
      return;
    }

    if (drawer.contains(focusedElement)) {
      const matchingLink = Array.from(desktopNavigation?.querySelectorAll('a') || []).find(
        (link) => link.href === focusedElement.href
      );
      (matchingLink || themeToggle)?.focus({ preventScroll: true });
    }
    closeDrawer();
  });

  document.addEventListener('click', (event) => {
    if (!drawer.open) {
      return;
    }

    if (!drawer.contains(event.target)) {
      closeDrawer(drawer.contains(document.activeElement));
    }
  });

  drawer.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      closeDrawer(drawer.contains(document.activeElement));
    });
  });
})();
